import * as type from './types';
import { createReducer } from "../../util/index";

//Set the initial state for the current page , current limit and current search values
const initialState = {
    data: []
};

const bannerReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.GET_BANNER_LIST]: (state = initialState, action) => ({
        ...state,
        banner_data: action.payload
    }),

    [type.DROPDOWN]: (state, action) => ({
      ...state,
      dropDown: action.value,
    }),

    [type.POST_BANNER]: (state, action) => ({
        ...state,
        post_banner_result: action.payload,
    }),

    [type.SHOW_BANNER]: (state, action) => ({
        ...state,
        show_banner_data: action.payload,
    }),

    [type.UPDATE_BANNER]: (state, action) => ({
        ...state,
        update_banner_result: action.payload,
    }),

    [type.DELETE_BANNER]: (state, action) => ({
        ...state,
        delete_banner_result: action.payload,
    }),

    [type.UPDATE_STATUS_BANNER]: (state, action) => ({
        ...state,
        update_status_banner_result: action.payload,
    }),

    [type.GET_CATEGORY]: (state = initialState, action) => ({
        ...state,
        category_data: action.payload
    }),

});

export default bannerReducer;